import * as types from '../mutation-types';

const initialState = {
  email: '',
  username: '',
  sid: '',
};

const mutations = {
  [types.USER_SET_DATA](state, payload) {
    state.email = payload.email;
    state.username = payload.username;
    state.sid = payload.sid;
  },
  [types.USER_REMOVE_DATA](state) {
    state.email = initialState.email;
    state.username = initialState.username;
    state.userpicUrl = initialState.userpicUrl;
  },
};

export default {
  state: { ...initialState },
  mutations,
};
